"use client";

import { GeoLocation } from "@/types/location";
import { createContext, useContext, useMemo, useState } from "react";

type HomeContext = {
  startLocation: GeoLocation | undefined;
  setStartLocation: (location: GeoLocation) => void;
  endLocation: GeoLocation | undefined;
  setEndLocation: (location: GeoLocation) => void;
};

const HomeContext = createContext<HomeContext | undefined>(undefined);

export function HomeProvider({ children }: { children: React.ReactNode }) {
  const [startLocation, setStartLocation] = useState<GeoLocation | undefined>(undefined);
  const [endLocation, setEndLocation] = useState<GeoLocation | undefined>(undefined);

  const value = useMemo(
    () => ({ startLocation, setStartLocation, endLocation, setEndLocation }),
    [startLocation, setStartLocation, endLocation, setEndLocation],
  );

  return <HomeContext.Provider value={value}>{children}</HomeContext.Provider>;
}

export function useHomeContext() {
  const context = useContext(HomeContext);
  if (!context) {
    throw new Error("useHomeContext must be used within a HomeProvider");
  }
  return context;
}
